import {Stack} from "@mui/material";
import {SupplierNameAvatar} from "../SupplierNameAvatar";
import {SupplierCanonicalNameEditor} from "../SupplierCanonicalNameEditor";

type SupplierCanonicalNameCellProps = {
    entityId: number;
    canonicalName: string;
    /** `SupplierEntity.logo_url` (§2.1) — `''` for a supplier with no logo, which shows initials instead. */
    logoUrl?: string;
};

export function SupplierCanonicalNameCell({
                                              entityId,
                                              canonicalName,
                                              logoUrl,
                                          }: SupplierCanonicalNameCellProps) {
    return (
        <Stack direction="row" alignItems="center" gap={1} sx={{minWidth: 0, width: '100%'}}>
            <SupplierNameAvatar name={canonicalName} entityId={entityId} logoUrl={logoUrl}/>
            <SupplierCanonicalNameEditor
                entityId={entityId}
                canonicalName={canonicalName}
                typographyProps={{variant: 'body2'}}
                inputSx={{height: '24px !important'}}
            />
        </Stack>
    );
}
